export const stockMap = [
  {
    name: '发行价',
    field: 'issue_price',
    unit: 'issue',
    value: '',
    hasPreValue: true,
  },
  {
    name: '发行市盈率(静)',
    field: 'issue_pe_static',
    unit: 'ttm',
    value: '',
    hasPreValue: true,
  },
  {
    name: '申购上限',
    field: 'order_limit_up',
    unit: '万股',
    value: '',
  },
  {
    name: '行业市盈率',
    field: 'industry_ttm',
    unit: 'ttm',
    value: '',
  },
  {
    name: '发行总数',
    field: 'issue_count',
    unit: '万股',
    value: '',
  },
  {
    name: '所属行业',
    field: 'industry_name',
    unit: '',
    value: '',
  },
  {
    name: '上市期是否盈利',
    field: 'is_profitable_before_listing',
    unit: '',
    value: null,
    // 格式化显示的值（如果有format属性则使用该属性显示）
    format: (value: string) => {
      if (value === '1') {
        return '是';
      }
      if (value === '0') {
        return '否';
      }
      return '--';
    },
    // 判断是否展示这个标签
    show: (value: string) => {
      return value === null || value === '' || value === undefined ? false : true;
    }
  }
]

export const bondMap = [
  {
    name: '发行量',
    field: 'issue_count',
    unit: '亿元',
    value: '',
  },
  {
    name: '转股价',
    field: 'conversion_price',
    unit: 'issue',
    value: '',
  },
  {
    name: '申购上限',
    field: 'order_limit_up',
    unit: '万张',
    value: '',
  },
  {
    name: '溢价率',
    field: 'premium_rate',
    unit: 'premium',
    value: '',
  },
  {
    name: '中签率',
    field: 'pre_success_rate',
    unit: 'winning',
    value: '',
  },
]

export const stockWillMap = [
  {
    name: '上市日',
    field: 'listing_date',
    unit: 'date',
    value: '',
  }, {
    name: '发行价',
    field: 'issue_price',
    unit: 'issue',
    value: '',
  }, {
    name: '中签率',
    field: 'success_rate',
    unit: 'winning',
    value: '',
  },
]

export const bondWillMap = [
  {
    name: '上市日',
    field: 'listing_date',
    unit: 'date',
    value: '',
  }, {
    name: '溢价率',
    field: 'premium_rate',
    unit: 'premium',
    value: '',
  }, {
    name: '中签率',
    field: 'success_rate',
    unit: 'winning',
    value: '',
  },
]

export const stockListedMap = [
  {
    name: '上市日',
    field: 'listing_date',
    unit: 'date',
    value: '',
  },
  {
    name: '发行价',
    field: 'issue_price',
    unit: 'issue',
    value: '',
  },
  {
    name: '每签最高获利',
    field: 'max_profit',
    unit: '元',
    value: '',
  },
  {
    name: '首日最高涨幅',
    field: 'max_change',
    unit: '%',
    value: '',
  },
  {
    name: '首日开盘涨幅',
    field: 'first_opening_change',
    unit: '%',
    value: '',
  },
  {
    name: '首日收盘涨幅',
    field: 'first_closing_change',
    unit: '%',
    value: '',
  },
  {
    name: '连续一字板',
    field: 'continuous_limit',
    unit: '',
    value: '',
  },
]

export const bondListedMap = [
  {
    name: '上市日',
    field: 'listing_date',
    unit: 'date',
    value: '',
  },
  {
    name: '首日涨幅',
    field: 'first_change',
    unit: '%',
    value: '',
  },
  {
    name: '每签获利',
    field: 'max_profit',
    unit: '元',
    value: '',
  },
  {
    name: '最新价',
    field: 'latest_price',
    unit: '元',
    value: '',
  },
  {
    name: '累计涨幅',
    field: 'grand_total_change',
    unit: '%',
    value: '',
  },
]

